import { render, staticRenderFns } from "./currentInfo.vue?vue&type=template&id=2fb94266&scoped=true"
import script from "./currentInfo.vue?vue&type=script&lang=js"
export * from "./currentInfo.vue?vue&type=script&lang=js"
import style0 from "./currentInfo.vue?vue&type=style&index=0&id=2fb94266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb94266",
  null
  
)

export default component.exports